<template>
    <div class="all">
    <!-- header开始 -->
    <v-header title="快捷入口"></v-header>
    <!-- header结束 -->
    <!-- <div class="conH"></div> -->        
    <div class="shortcutMenu">
        <ul class="tubiao">
          <li v-for="(item, index) in result" :key="index" @click="toURLParameter(item.url)">
            <div class="liimg"><img :src="item.imUrl"></div>
            <span>{{item.privName}}</span>
          </li>
      </ul>
    </div>
    </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'
export default {
  name: 'shortcutMenu',
  components: {
    vHeader
  },
  data () {
    return {
      result: []
      
    }
  },
  methods: {
   getMenuInfo () {
      let submitInfo = {
        pid: '47c71b6e0dea4a5f8fa9331dc53538bb'
      }
      let that = this
      // 调用接口保存告知数据
      api.getMenuInfo(submitInfo, function (res) {
        if (res.result.isSuccess === true) {
          that.result = res.data.menus.children
          // that.showStatus = that.result.length
          console.log(that.result)
          // console.log(that.showStatus)
          let arr=that.result
          console.log(arr,'菜单')
          let newArr = []
          for (var i = 0; i < arr.length; i++) {
            // newArr.push(arr[i])
            if (arr[i].privName !== '人气产品' && arr[i].privName !== '电子杂志' && arr[i].privName !== '活动量'  && arr[i].privName !== '荣耀殿堂' && arr[i].privName !== '培训资料') {
                newArr.push(arr[i])                                
            }

            if(arr[i].privName=='人气产品'){
              that.proUrl = arr[i].url
            }
            if(arr[i].privName=='电子杂志'){
              that.zazhiimg = arr[i].imUrl
            }
            if(arr[i].privName=='活动量'){
              that.activityUrl = arr[i].url
            }
            if(arr[i].privName=='荣耀殿堂'){
              that.honourUrl = arr[i].url
              that.honourimg = arr[i].imUrl
            }
            
          }
          that.result = newArr
        } else {
          that.$toast(res.result.error)
        }
      })
    },

    toURLParameter(url){
      let that = this
      if (url === '') {
          that.$message('敬请期待')
      } else if (url.slice(0, 4) === 'http') {
          window.open(url)
      } else if(url.slice(0, 1) === '/'){           
          that.$router.push({path: url})
      }else{
          that.$router.push({path:'/' + url})
      }
    }

    
 
  },
  mounted () {
   this.getMenuInfo()
  },
  created: function () {
    
  }
}
</script>

<style scoped>
.all{
  width: 94%;
  margin: 20px auto;
  /* font-weight: 500; */
  margin-top: 80px;
  height: calc(100% - 100px);
  background: #fff;
  overflow: hidden;
}
.shortcutMenu{
  width: 94%;
  height: 100%;
  margin: auto;
  box-sizing: border-box;
}
.tubiao {
  height: 100%;
  width:100%;  
  margin: 0 auto;
  padding: 0;
  margin: 0;
}
.tubiao li {
  float: left;
  /* width: 25%; */
  list-style: none;
  width: 12.5%;
  text-align: center;
  /* height: 40%; */
  margin-top: 5%;
}
.tubiao li span {
  display: block;
  color: #194793;
  font-size: 12px;
  margin-top: 10%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.liimg {
  height: 40px;
  height: 40px;
  margin: 0 auto;
}
.liimg img {
  height: 40px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shortcutMenu.vue